import { memo } from 'react';
import { EditProfileMediaDocumentsImageItem } from '../EditProfileMediaDocumentsImageItem/EditProfileMediaDocumentsImageItem';
import { EditProfileDocumentsImageListContainer } from '../EditProfileMediaDocumentsImage.styles';
import { EditProfileDocumentAttachedListProps } from 'shared/interfaces/IRepresentativesEditProfile';

const EditProfileDocumentAttached = ({ attached_medias }: EditProfileDocumentAttachedListProps) => {
  return (
    <EditProfileDocumentsImageListContainer>
      {attached_medias.map((attached_media, index) => (
        <li style={{ listStyle: 'none' }} key={attached_media.medium.id}>
          <EditProfileMediaDocumentsImageItem attached_image={attached_media} index={index + 1} />
        </li>
      ))}
    </EditProfileDocumentsImageListContainer>
  );
};

export default memo(EditProfileDocumentAttached);
